import { useState } from "react";
import type { Game } from "@/mocks/games";

interface ShareBarProps {
  game: Game;
}

export default function ShareBar({ game }: ShareBarProps) {
  const [toast, setToast] = useState("");

  const shareUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
  const shareTitle = `${game.name} - 网页游戏直接玩`;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(shareTitle);

  const showToast = (message: string) => {
    setToast(message);
    window.setTimeout(() => setToast(""), 2200);
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      showToast("链接已复制到剪贴板");
    } catch {
      showToast("复制失败，请手动复制地址栏链接");
    }
  };

  const platforms = [
    { icon: "ri-weibo-fill", label: "微博", href: `https://service.weibo.com/share/share.php?url=${encodedUrl}&title=${encodedTitle}` },
    { icon: "ri-qq-fill", label: "QQ", href: `https://connect.qq.com/widget/shareqq/index.html?url=${encodedUrl}&title=${encodedTitle}` },
    { icon: "ri-wechat-fill", label: "微信", href: "" },
    { icon: "ri-links-fill", label: "复制链接", href: "" },
  ];

  return (
    <div className="relative">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm font-bold text-foreground-700">分享到：</span>
        {platforms.map((platform) => {
          const isActionButton = platform.label === "微信" || platform.label === "复制链接";
          const handleClick = () => {
            if (platform.label === "微信") {
              showToast("请复制链接后在微信中打开");
            } else if (platform.label === "复制链接") {
              copyLink();
            }
          };
          if (isActionButton) {
            return (
              <button
                key={platform.label}
                type="button"
                onClick={handleClick}
                aria-label={platform.label}
                title={platform.label}
                className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
              >
                <i className={`${platform.icon}`}></i>
              </button>
            );
          }
          return (
            <a
              key={platform.label}
              href={platform.href}
              target="_blank"
              rel="noreferrer noopener"
              aria-label={platform.label}
              title={platform.label}
              className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-700 transition hover:border-primary-300 hover:text-primary-600"
            >
              <i className={`${platform.icon}`}></i>
            </a>
          );
        })}
      </div>
      {toast && (
        <div className="absolute left-0 top-full z-20 mt-2 flex items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-xs text-background-50 animate-fade-in">
          <i className="ri-check-line text-secondary-400"></i>
          {toast}
        </div>
      )}
    </div>
  );
}